module.exports = __webpack_public_path__ + "static/media/reviewdale-text.f7145422.svg";